module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activityDetail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    活动管理 > 查看详情\n    "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活动名称：")]), _vm._v(_vm._s(_vm.activity.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活动类型：")]), _vm._v(_vm._s(_vm.activity.activityType) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title activityIcon"
  }, [_vm._v("封面图：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.activity.bigImageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("奖品类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.prizeType))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活动列表展示：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.listShow))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活动是否开启报名：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.openJoin))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活动参与名额:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.maxJoinCount))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活动链接：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.clickType))]), _vm._v(_vm._s(_vm.activity.activityUrl) + "\n        ")]), _vm._v(" "), (_vm.activity.smallImageUrl) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title imgSpan"
  }, [_vm._v("APP跑步详情处提示：")]), _vm._v(" "), _c('span', {
    staticClass: "activityIcon"
  }, [_vm._v("活动图标：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.activity.smallImageUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("中奖方式：")]), _vm._v(_vm._s(_vm.activity.rewardType) + "\n          "), (_vm.activity.rewardType != '所有奖励使用后可再次中奖') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.activity.limitCount || 0) + "次。\n\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("起止日期：")]), _vm._v(_vm._s(_vm.activity.startTime) + " 至 " + _vm._s(_vm.activity.endTime) + "\n        ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.activity
    }
  }, [_c('select-school', {
    attrs: {
      "schObj": _vm.activity.schObj,
      "canUse": _vm.canUse
    }
  })], 1)], 1), _vm._v(" "), (_vm.activity.activityType == '跑步奖励' && _vm.activity.activityRunDetail != null) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("针对的跑步类型:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.activityRunDetail.runType))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("是否屏蔽跑步结束页广告:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.activityRunDetail.isBindEndAd))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("APP跑步结果页活动入口:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.activityRunDetail.runEndMsgType))])]), _vm._v(" "), (_vm.activity.activityRunDetail.msgPicUrl) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title activityIcon"
  }, [_vm._v("入口图片:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.activity.activityRunDetail.msgPicUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("点击事件:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.activityRunDetail.clickType))])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("点击事件url:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activity.activityRunDetail.clickUrl))])]), _vm._v(" "), (_vm.activity.activityRunDetail.showPopupPrompt) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("是否弹窗提示：")]), _vm._v(_vm._s(_vm.activity.activityRunDetail.isPopup === 1 ? '是' : '否') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.activity.activityRunDetail.showPopupPrompt && _vm.activity.activityRunDetail.isPopup === 1) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹窗内容：")]), _vm._v(_vm._s(_vm.activity.activityRunDetail.popupContent) + "\n        ")]) : _vm._e()]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cd9c365!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/activity/activityDetail.vue
// module id = 1017
// module chunks = 0